module.exports = __webpack_public_path__ + "static/media/reg4.c21433d2.jpg";